import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components";
import { CONSTANTS } from "app/constants";
import { DrawingBasketDto, DrawingEuroPlayoffResultDto, FixtureDto, TeamShortDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawing-playoff',
    templateUrl: './drawing-playoff.component.html',
    styleUrls: ['./drawing-playoff.component.scss'],
})
export class DrawingPlayOff implements OnInit {

    @Input()
    stage: number;

    @Input()
    lch: DrawingBasketDto;

    @Input()
    le: DrawingBasketDto;

    @Input()
    lk: DrawingBasketDto;

    stages: any[];

    const;

    matchDay1: number;
    matchDay2: number;
    
    @Input()
    fixtures: DrawingEuroPlayoffResultDto;

    constructor(private modalService: NgbModal, private notificationService: NotificationService,
        private drawingService: DrawingsService) {
        this.const = CONSTANTS;
     }

    ngOnInit(): void {
        this.buildEuroStagesDictionary();
    } 

    getStageLabel(): string {
        return this.stages[this.stage];
    }

    onChangeTeam(index: number, basketNumber: number, tournament: number) {
        const modalRef = this.modalService.open(TeamShortModal);

        let basket = this.getBasket(basketNumber, tournament);

        modalRef.componentInstance.team = basket[index];

        modalRef.result.then((result) => {
            if (result) {
                basket[index] = result;
            }
        }, (reason) => { });
    }

    onAddTeam(basketNumber: number, tournament: number) {
        const modalRef = this.modalService.open(TeamShortModal);

        let basket = this.getBasket(basketNumber, tournament);

        modalRef.componentInstance.team =null;

        modalRef.result.then((result) => {
            if (result) {
                basket.unshift(result);
            }
        }, (reason) => { });
    }

    onDeleteTeam(index: number, basketNumber: number, tournament: number) {
        let basket = this.getBasket(basketNumber, tournament);

        basket.splice(index, 1);
    }

    doDraw() {
        if (!this.matchDay1 || !this.matchDay2){
            this.notificationService.showError('Не выбраны ИД!');
            return;
        }

        let allTeams = [];

        this.lch.basket1.forEach(item => {
            allTeams.push(item.id);
        });
        this.lch.basket2.forEach(item => {
            allTeams.push(item.id);
        });
        this.le.basket1.forEach(item => {
            allTeams.push(item.id);
        });
        this.le.basket2.forEach(item => {
            allTeams.push(item.id);
        });
        this.lk.basket1.forEach(item => {
            allTeams.push(item.id);
        });
        this.lk.basket2.forEach(item => {
            allTeams.push(item.id);
        });

        if (new Set(allTeams).size !== allTeams.length) {
            this.notificationService.showError('Среди команд есть дубли!');
            return;
        }

        this.drawingService.drawPlayoff(this.stage, this.matchDay1, this.matchDay2, this.lch, this.le, this.lk)
            .subscribe(result => {
                this.notificationService.showSuccess("Жеребьевка проведелна");
                this.fixtures = result;
            }, error=> {
                this.notificationService.showError("Error!");
            })

        
    }

    isDrawn(): boolean {
        //return false;

        return this.fixtures && this.fixtures.championsLeagureFixtures && this.fixtures.confferrenceLeagureFixtures && this.fixtures.euroLeagureFixtures
            && (this.fixtures.championsLeagureFixtures.length >0 || this.fixtures.confferrenceLeagureFixtures.length > 0 && this.fixtures.euroLeagureFixtures.length > 0);
    }

    private getBasket(basketNumber: number, tournament: number): TeamShortDto[] {
        let euroBasket: DrawingBasketDto;

        switch(tournament) {
            case CONSTANTS.euroCups.europeLeague:
                euroBasket = this.le;
                break;
            case CONSTANTS.euroCups.chamionsLeague:
                euroBasket = this.lch;
                break;
            case CONSTANTS.euroCups.conferenceLeague:
                euroBasket = this.lk;
                break;
        }

        return basketNumber === 1 ? euroBasket.basket1 : euroBasket.basket2;
    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages[CONSTANTS.euroCupStages.qual1] = CONSTANTS.euroCupStagesNames.qual1;
        this.stages[CONSTANTS.euroCupStages.qual2] = CONSTANTS.euroCupStagesNames.qual2;
        this.stages[CONSTANTS.euroCupStages.group] = CONSTANTS.euroCupStagesNames.group;
        this.stages[CONSTANTS.euroCupStages.playoff32] = CONSTANTS.euroCupStagesNames.playoff32;
        this.stages[CONSTANTS.euroCupStages.playoff16] = CONSTANTS.euroCupStagesNames.playoff16;
        this.stages[CONSTANTS.euroCupStages.playoff8] = CONSTANTS.euroCupStagesNames.playoff8;
        this.stages[CONSTANTS.euroCupStages.playoff4] = CONSTANTS.euroCupStagesNames.playoff4;
        this.stages[CONSTANTS.euroCupStages.playoff2] = CONSTANTS.euroCupStagesNames.playoff2;
        this.stages[CONSTANTS.euroCupStages.final] = CONSTANTS.euroCupStagesNames.final;
    }

}

